import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

class MedicalRecordsService {
  async getPatientRecords() {
    try {
      const response = await axios.get(`${API}/medical-records/patient`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to fetch medical records:', error);
      return { success: false, error: error.response?.data?.detail || 'Failed to fetch records' };
    }
  }

  async uploadMedicalRecord(recordData) {
    try {
      const response = await axios.post(`${API}/medical-records`, recordData);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to upload medical record:', error);
      return { success: false, error: error.response?.data?.detail || 'Failed to upload record' };
    }
  }

  async shareMedicalRecord(recordId, doctorId, permissions = {}) {
    try {
      const response = await axios.post(`${API}/medical-records/${recordId}/share`, {
        doctor_id: doctorId,
        permissions: {
          view: permissions.view || true,
          download: permissions.download || false,
          edit: permissions.edit || false,
          ...permissions
        }
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to share medical record:', error);
      return { success: false, error: error.response?.data?.detail || 'Failed to share record' };
    }
  }

  async getSharedRecords() {
    try {
      const response = await axios.get(`${API}/medical-records/shared`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to fetch shared records:', error);
      return { success: false, error: error.response?.data?.detail || 'Failed to fetch shared records' };
    }
  }

  async revokeMedicalRecordAccess(recordId, doctorId) {
    try {
      const response = await axios.delete(`${API}/medical-records/${recordId}/share/${doctorId}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to revoke access:', error);
      return { success: false, error: error.response?.data?.detail || 'Failed to revoke access' };
    }
  }

  async downloadMedicalRecord(recordId) {
    try {
      const response = await axios.get(`${API}/medical-records/${recordId}/download`, {
        responseType: 'blob'
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to download medical record:', error);
      return { success: false, error: error.response?.data?.detail || 'Failed to download record' };
    }
  }

  async addMedicalNote(appointmentId, note) {
    try {
      const response = await axios.post(`${API}/medical-records/notes`, {
        appointment_id: appointmentId,
        note: note,
        created_at: new Date().toISOString()
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to add medical note:', error);
      return { success: false, error: error.response?.data?.detail || 'Failed to add note' };
    }
  }

  async getMedicalHistory() {
    try {
      const response = await axios.get(`${API}/medical-records/history`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to fetch medical history:', error);
      return { success: false, error: error.response?.data?.detail || 'Failed to fetch history' };
    }
  }
}

export default new MedicalRecordsService();